import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WidthFullIcon(props: IconProps) {
    return <Icon {...props} iconKey={"width_full"}/>
}
